import router from './router'
import store from './store'
import { getToken } from '@/utils/auth' // get token from cookie
import { titleController } from "@/utils"


// 路由前置守卫
router.beforeEach(async(to, from, next) => {
    // start progress bar

    const hasGetUserInfo = store.getters.user //获取用户信息
    const hasToken = getToken()
    // 是否有token
    if(hasToken) {
        if (to.path === '/register') {
            // if is logged in, redirect to the home page
            next({ path: '/' })
        }else {
            // 看一下是否用户信息
            if (hasGetUserInfo) {
                next()
            } else {
                // 没有用户信息 ，但是有token => 获取cookie里的token 获取用户信息
                try {
                    // get user info
                    await store.dispatch('user/getInfo')
                    next()
                } catch (error) {
                    // remove token and go to login page to re-login
                    await store.dispatch('user/resetToken')
                    next(`/`)
                }
            }
        }
    }else {
        // has no token
        if (to.meta.auth) {
            //  other pages that do not have permission to access are redirected to the login page.
            next(`/`)
        } else {
            // in the free login, go directly
            next()
        }
    }
})

router.afterEach((to, from) => {
    if (to.meta.title) {
      titleController.setRouteTitle(to.meta.title)
    }
})